export default {
  'open-menu': 'Öppna menyn',
  'close-menu': 'Stäng',
  'editorial-staff': 'Redaktion',
  about: 'Om oss',
  shopLink: 'En värld av möjligheter',
}
